import { useModalContext } from 'src/hooks/useModalContext';
import { EventShopModalProps } from '../types';

export const useScrollToHowToEarn = () => {
  const { closeModal } = useModalContext<EventShopModalProps>();
  const handleToHowToEarn = () => {
    closeModal();
    const freespinsInGames = document.getElementById('howToEarn');
    freespinsInGames?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return { handleToHowToEarn };
};
